import { CampaignSendSizeState } from 'modules/campaigns/editor/context';

type UseCampaignSendSizeProps = {
  expectedSendSizeData: CampaignSendSizeState;
  estimatedSendSizeData: CampaignSendSizeState;
};

export const useCampaignSendSize = ({
  estimatedSendSizeData,
  expectedSendSizeData,
}: UseCampaignSendSizeProps) => {
  const isExpectedSendSize = typeof expectedSendSizeData?.sendSize === 'number';
  const data = isExpectedSendSize ? expectedSendSizeData : estimatedSendSizeData;

  return {
    ...data,
    isEstimated: !isExpectedSendSize,
  };
};
